// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__P8wHf","title":"BackImages_title__2hGil","images":"BackImages_images__zhTF_"};